import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import type { LabeledValueType } from 'components/CIMSSelect/types'
import type { PayItemsSelectProps } from '../types'

/** Displays retained pay-item labels while keeping form values as ID arrays. */
function PayItemsSelect({
  accessibility,
  disabled,
  field,
  onBlur,
  onChange,
  payItems,
  value,
}: PayItemsSelectProps) {
  const optionIds = Array.isArray(value)
    ? value.filter(
        (optionId): optionId is string => typeof optionId === 'string'
      )
    : []
  const payItemsById = new Map(
    payItems.map((payItem) => [payItem.globalId.toLowerCase(), payItem])
  )
  const selections: LabeledValueType[] = optionIds.map((optionId) => {
    const payItem = payItemsById.get(optionId.toLowerCase())
    return {
      value: optionId,
      label: payItem?.label ?? optionId,
      deleted: payItem?.deleted,
    }
  })

  return (
    <PayItemSelect
      {...accessibility}
      allowClear={!disabled}
      disabled={disabled}
      mode={field.single ? undefined : 'multiple'}
      onBlur={onBlur}
      onChange={(selection) => {
        if (Array.isArray(selection))
          onChange(
            selection.flatMap((item) =>
              typeof item === 'object' && typeof item.value === 'string'
                ? [item.value]
                : []
            )
          )
        else if (
          typeof selection === 'object' &&
          selection !== null &&
          typeof selection.value === 'string'
        )
          onChange([selection.value])
        else onChange([])
      }}
      style={{ width: '100%' }}
      value={field.single ? selections[0] : selections}
    />
  )
}

export default PayItemsSelect
